<div class="footer">
  <div class="footer__link">
    <pre class="footer__link-item">
      v{{ version }} | #{{ githash }} | {{ gitcomment }} ({{ projectId }})
    </pre>
  </div>
  <div class="footer__icon">
  </div>
</div>
